
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { MenuItem, Menu } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tweet from './utils/Tweet';

const styles = theme => ({
});

const ContextMenu = (props) => {
    const { open, anchorEl, context, handleClose, handleEdit, handleDelete, owner } = props;
    return (
        <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={open}
            onClose={handleClose}
        >
            <MenuItem onClick={handleClose}><Tweet text={context.text} /></MenuItem>
            { owner && [
                <MenuItem key="0" onClick={handleDelete}><DeleteIcon /></MenuItem>,
                <MenuItem key="1" onClick={handleEdit}><EditIcon /></MenuItem>
                ]}
        </Menu> 
    );           

}

ContextMenu.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(ContextMenu);